import decode from 'jwt-decode';
import axios from "axios";
import keycloak from "../config/keycloak/keycloak";
export default class AuthService {
    constructor(domain) {
        this.domain = domain
        this.fetch = this.fetch.bind(this)
        this.login = this.login.bind(this)
        this.getProfile = this.getProfile.bind(this)
    }
    init() {
        this.setToken(keycloak.token);
    }
    login(username, password) {
        // Get a token
        return this.fetch(`${this.domain}user`, {
            method: 'POST',
            body: JSON.stringify({
                username,
                password
            })
        }).then(response => response.json()).then(res => {
            this.setToken(res.token)
            return Promise.resolve(res);
        })
    }
    loggedIn() {
        // Checks if there is a saved token and it's still valid
        const token = this.getToken()
        return !!token /* && !this.isTokenExpired(token) */ // handwaiving here
    }
    isTokenExpired(token) {
        try {
            const decoded = decode(token);
            if (decoded.exp < Date.now() / 1000) {
                return true;
            }
            else
                return false;
        }
        catch (err) {
            return false;
        }
    }
    setToken(idToken) {
        // Saves user token to localStorage
        localStorage.setItem('id_token', idToken)
    }
    getToken() {
        // Retrieves the user token from localStorage
        return localStorage.getItem('id_token')
    }
    logout() {
        // Clear user token and profile data from localStorage
        if (keycloak != null) {
            keycloak.logout();
        }
    }
    getProfile() {
        return decode(this.getToken());
    }
    checkRole(role) {
        let user = this.getProfile();
        return user.roles.indexOf(role) !== -1
    }
    async fetch(url, options) {
        if (this.isTokenExpired(this.getToken())) {
            this.setToken(keycloak.idToken);
        }
        const headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
        if (this.loggedIn()) {
            headers['Authorization'] = 'Bearer ' + this.getToken()
        }
        return fetch(url, {
            headers,
            ...options
        })
            .then(this._checkStatus);
    }
    async redirectToKeycloak(referrerUrl) {
        try {
            const clientId = keycloak.clientId;
            const safeRedirectUri = encodeURIComponent(referrerUrl);
            const keycloakUrl = `process.env.REACT_APP_KEYCLOACK_URL + 'realms/OsosWeb/protocol/openid-connect/auth`;
            const params = `?client_id=${encodeURIComponent(clientId)}&redirect_uri=${safeRedirectUri}&response_mode=fragment&response_type=code&scope=openid`;
            window.location.replace(keycloakUrl + params);
        } catch (e) {
            console.error('Geçersiz URL: ', e);
        }
    }
    async axios(url, data, params) {
        if (this.isTokenExpired(this.getToken())) {
            try {
                await keycloak.updateToken(70);
                this.setToken(keycloak.idToken);
            } catch (error) {
                // Token yenileme basarısız olursa kullanıcıyı Keycloak login sayfasina yonlendirir
                var referrer = document.referrer === "" ? document.baseURI : document.referrer;
                this.redirectToKeycloak(referrer);
                return;
            }
        }
        const headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
        // console.log(this.getToken());

        if (this.loggedIn()) {
            headers['Authorization'] = 'Bearer ' + this.getToken()
        }
        // console.log(process.env.REACT_APP_API_URL+url);
        if (data !== null) {
            return await axios.post(`${process.env.REACT_APP_API_URL + url}`, data, { headers: headers }).catch(this._checkStatus)
        }
        else if (params !== null) {
            return await axios.get(`${process.env.REACT_APP_API_URL + url}`,
                {
                    params,
                    headers
                }).catch(this._checkStatus)
        }
        else {
            return await axios.get(`${process.env.REACT_APP_API_URL + url}`, { headers: headers }).catch(this._checkStatus)
        }
    }
    async fetchForm(url, options) {
        if (this.isTokenExpired(this.getToken())) {
            this.setToken(keycloak.token);
        }
        const headers = {};
        if (this.loggedIn()) {
            headers['Authorization'] = 'Bearer ' + this.getToken()
        }
        return fetch(url, {
            headers,
            ...options
        }).then(this._checkStatus);
    }
    _checkStatus(response) {
        if (response.response.status >= 200 && response.response.status < 300) {
            return response
        } else {
            if (response.response.status === 403) {
                window.location = '/forbidden';
                return false;
            }
            if (response.response.status === 404) {
                window.location = '/404';
                return false;
            } else if (response.response.status === 400) {
                response.clone().json().then(json => {
                    if (json.isGlobalException) {
                        //alert(json.message);
                        //window.location.reload();
                    }
                });
                return response;
            }
            else {
                return response;
            }
        }
    }
}
